import { UseCaseRecursoAsync } from "src/views/core/types/UseCaseRecursoAsync";
import { EstadoApi } from "../entities/EstadoApi.entity";
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';
import { Recurso } from 'lib.common/dist/CleanArch';
import { EstadosApisRepository } from "../repositories/EstadosApisRepository";

export class GetEstadosApisUseCase<T_OUT extends EstadoApi> extends UseCaseRecursoAsync<
    null, T_OUT[]
> {
    private repository: EstadosApisRepository<T_OUT>;
    constructor(repository: EstadosApisRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(): Promise<Recurso<T_OUT[]>> {
        try {
            return this.repository.getEstadosApis();
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }
}